import { getAccountType, getUserRole } from './sessionStore';
import { isHospitalRole } from './userDashboardPermissions';

/**
 * True when the session belongs to the hospital UserDashboard (customer portal),
 * not Spotless staff admin chrome.
 */
export function isClientPortalUser() {
  const accountType = getAccountType();
  if (accountType === 'customer') return true;
  if (accountType === 'admin' || accountType === 'robotController') return false;
  const role = getUserRole();
  return isHospitalRole(role);
}
